import React from "react";
import Placeholder from "./Placeholder";
import { PROTOTYPE_ROUTES, showPrototypes } from "../lib/prototypeFlag";
import { useLocation } from "react-router-dom";

/**
 * Gates a prototype page behind the REACT_APP_SHOW_PROTOTYPES env flag
 * (or `?prototypes=1` runtime escape hatch). When the flag is OFF, renders
 * the existing Placeholder ("Coming Soon · Q2 2026") with copy specific
 * to the route. When ON, renders the actual prototype.
 *
 * This is the single seam for revealing or hiding all 8 prototype pages —
 * no router edits or sidebar tweaks needed when one ships for real.
 */
export const PrototypeGate = ({ matchPath, children }) => {
  const location = useLocation();
  const path = matchPath || location.pathname;
  const meta = PROTOTYPE_ROUTES[path] ||
    Object.entries(PROTOTYPE_ROUTES).find(([k]) => path.startsWith(k + "/"))?.[1] ||
    { title: "Coming Soon", subtitle: "This experience is still in design." };

  if (showPrototypes()) return <>{children}</>;
  return <Placeholder title={meta.title} subtitle={meta.subtitle} />;
};
